import { render, staticRenderFns } from "./DashboardCostForecast.vue?vue&type=template&id=4d6d3e31&scoped=true"
import script from "./DashboardCostForecast.vue?vue&type=script&lang=js"
export * from "./DashboardCostForecast.vue?vue&type=script&lang=js"
import style0 from "./DashboardCostForecast.vue?vue&type=style&index=0&id=4d6d3e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d3e31",
  null
  
)

export default component.exports